import $ from 'jquery';

let bPrevented = false;

const keydownEventListener = (event) => {
    if (event.key === 'Escape' && bPrevented) {
        event.stopImmediatePropagation();
        return false;
    }
};

export const preventEscapeKey = () => {
    if (!bPrevented) {
        $(document).on('keydown', keydownEventListener);
        bPrevented = true;
    }
};

export const releaseEscapeKey = () => {
    if (bPrevented) {
        $(document).off('keydown', keydownEventListener);
        bPrevented = false;
    }
};
